module.exports = __webpack_public_path__ + "img/blud-t1.83692172.png";